// سجلّ القراءة يوماً بيوم: الصفحات التي فُتحت في المصحف كل يوم.
//
// الصفحة تُحسب مرة في اليوم مهما رجع إليها القارئ. ويُحفظ آخر ٩٠ يوماً.

import { dayKey, daysBetween } from './khatma';

const KEY = 'moslam_reading_log';
const KEEP_DAYS = 90;

/** @returns {Record<string, number[]>} اليوم ← صفحاته */
export function readLog() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || '{}');
    return v && typeof v === 'object' && !Array.isArray(v) ? v : {};
  } catch {
    return {};
  }
}

/** يسجّل صفحة لليوم، ويحذف ما قدُم. */
export function logPage(page, today = dayKey()) {
  if (!Number.isInteger(page) || page < 1) return;
  const log = readLog();
  const pages = log[today] ?? [];
  if (pages.includes(page)) return;
  const next = { [today]: [...pages, page] };
  for (const [day, list] of Object.entries(log)) {
    if (day !== today && daysBetween(day, today) < KEEP_DAYS) next[day] = list;
  }
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // التخزين ممنوع — لا سجلّ
  }
}

/**
 * إحصائيات آخر `span` يوماً حتى اليوم.
 * @returns {{ days: Array<{ day, count }>, total, average, streak, best }}
 */
export function readingStats(log, span = 14, today = dayKey()) {
  const [y, m, d] = today.split('-').map(Number);
  const days = Array.from({ length: span }, (_, i) => {
    const day = dayKey(new Date(y, m - 1, d - (span - 1 - i)));
    return { day, count: log[day]?.length ?? 0 };
  });
  const total = days.reduce((s, x) => s + x.count, 0);
  const active = days.filter((x) => x.count > 0).length;
  // أيام متتالية حتى اليوم؛ اليوم الذي لم يُقرأ فيه بعد لا يقطعها
  let streak = 0;
  for (let i = days.length - 1; i >= 0; i--) {
    if (days[i].count > 0) streak += 1;
    else if (i !== days.length - 1) break;
  }
  return {
    days,
    total,
    average: active ? Math.round((total / active) * 10) / 10 : 0,
    streak,
    best: Math.max(0, ...days.map((x) => x.count)),
  };
}

/* ------------------------------ الاستماع ------------------------------ */

const LISTEN_KEY = 'moslam_listening_log';

/** @returns {Record<string, number>} اليوم ← ثواني الاستماع */
export function readListening() {
  try {
    const v = JSON.parse(localStorage.getItem(LISTEN_KEY) || '{}');
    return v && typeof v === 'object' && !Array.isArray(v) ? v : {};
  } catch {
    return {};
  }
}

/** يضيف ثواني استماع لليوم، ويحذف ما قدُم. */
export function logListening(seconds, today = dayKey()) {
  if (!(seconds > 0)) return;
  const log = readListening();
  const next = { [today]: (log[today] ?? 0) + Math.round(seconds) };
  for (const [day, s] of Object.entries(log)) {
    if (day !== today && daysBetween(day, today) < KEEP_DAYS) next[day] = s;
  }
  try {
    localStorage.setItem(LISTEN_KEY, JSON.stringify(next));
  } catch {
    // التخزين ممنوع — لا سجلّ
  }
}

/** دقائق الاستماع في آخر `span` يوماً حتى اليوم. */
export function listeningMinutes(log, span = 14, today = dayKey()) {
  let total = 0;
  for (const [day, s] of Object.entries(log)) {
    const ago = daysBetween(day, today);
    if (ago >= 0 && ago < span) total += s;
  }
  return Math.round(total / 60);
}
